/**
 * Plays a short pleasant ding sound using the Web Audio API.
 * Synthesised on the fly — no audio file needed.
 * Silently no-ops if audio is unavailable or blocked by browser policy.
 */

let _ctx = null;

function getAudioContext() {
    if (_ctx && _ctx.state !== 'closed') return _ctx;
    try {
        _ctx = new (window.AudioContext || window.webkitAudioContext)();
    } catch {
        _ctx = null;
    }
    return _ctx;
}

export function playDing() {
    const ctx = getAudioContext();
    if (!ctx) return;

    const resume = ctx.state === 'suspended' ? ctx.resume() : Promise.resolve();
    resume.then(() => {
        try {
            const t = ctx.currentTime;

            // First partial — the "attack" note
            const osc1 = ctx.createOscillator();
            const gain1 = ctx.createGain();
            osc1.connect(gain1);
            gain1.connect(ctx.destination);
            osc1.type = 'sine';
            osc1.frequency.setValueAtTime(1047, t);          // C6
            gain1.gain.setValueAtTime(0.0, t);
            gain1.gain.linearRampToValueAtTime(0.35, t + 0.01);
            gain1.gain.exponentialRampToValueAtTime(0.001, t + 0.6);
            osc1.start(t);
            osc1.stop(t + 0.65);

            // Second partial — softer overtone for richness
            const osc2 = ctx.createOscillator();
            const gain2 = ctx.createGain();
            osc2.connect(gain2);
            gain2.connect(ctx.destination);
            osc2.type = 'sine';
            osc2.frequency.setValueAtTime(1568, t);          // G6
            gain2.gain.setValueAtTime(0.0, t);
            gain2.gain.linearRampToValueAtTime(0.15, t + 0.01);
            gain2.gain.exponentialRampToValueAtTime(0.001, t + 0.4);
            osc2.start(t);
            osc2.stop(t + 0.45);
        } catch {
            // Silently ignore if playback fails
        }
    }).catch(() => {});
}

/**
 * Prime the AudioContext on the first user interaction so that
 * subsequent calls to playDing() are not blocked by autoplay policy.
 * Call this once from a top-level click/keydown handler.
 */
export function primeAudio() {
    getAudioContext();
}
